module.exports = __webpack_public_path__ + "img/빈도_팝업.a2447d0d.png";